import {
    ENTREGACERTA_LIST,
    ENTREGACERTA_LIST_LOADING,
    ENTREGACERTA_LIST_EVENTOS,
    ENTREGACERTA_SAVE_LOADING
} from './ActionsTypes';

import * as Api from '../utils/API';

export const nunotaListAction = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {


        dispatch({ type: ENTREGACERTA_LIST_LOADING, payload: true });

        Api.postEntregaCertaList(entidade).then(dados => {
            dispatch({ type: ENTREGACERTA_LIST, payload: dados });

            Api.postEntregaCertaEvento(entidade).then(item => {
                dispatch({ type: ENTREGACERTA_LIST_EVENTOS, payload: item });
                dispatch({ type: ENTREGACERTA_LIST_LOADING, payload: false });
                resolve(item)
            })
        })
    }
    )

export const nunotaSavection = (entidade) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch({ type: ENTREGACERTA_SAVE_LOADING, payload: true });


        Api.postEntregaCertaSave(entidade).then(dados => {
            dispatch({ type: ENTREGACERTA_SAVE_LOADING, payload: false });
            console.log(dados)
            resolve('Ok')
        })
    }
    )

